
import React from "react";

export const BackgroundEffects = () => {
  return (
    <>
      {/* Lighter primary layered background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-sky-50/20 via-white to-white" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_1200px_at_50%_-100px,rgba(14,165,233,0.05),transparent)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_100%_200px,rgba(14,165,233,0.03),transparent)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_600px_at_0%_400px,rgba(16,185,129,0.03),transparent)]" />
      
      {/* Even lighter secondary gradient effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_1200px_at_100%_200px,rgba(14,165,233,0.04),transparent)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_800px_at_0%_300px,rgba(16,185,129,0.03),transparent)]" />
      <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(240,249,255,0.3),transparent)]" />
      
      {/* Very subtle animated grid background */}
      <div className="absolute inset-0 bg-grid-white/[0.01] bg-[size:60px_60px] animate-grid-fade opacity-20" />
      
      {/* Bottom fade effect - lighter */}
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-sky-50/5 via-sky-50/3 to-transparent pointer-events-none" />
      
      {/* Floating elements - subtler and more professional */}
      <div className="absolute top-1/4 left-10 w-3 h-3 bg-sky-300/20 rounded-full blur-sm animate-float hidden sm:block" />
      <div className="absolute top-1/3 right-10 w-4 h-4 bg-emerald-300/20 rounded-full blur-sm animate-float hidden sm:block" style={{ animationDelay: '1s' }} />
      <div className="absolute bottom-1/4 left-1/4 w-5 h-5 bg-sky-300/20 rounded-full blur-sm animate-float hidden sm:block" style={{ animationDelay: '2s' }} />
    </>
  );
};
